import { renderContainerForWebchatContent } from './renderContainerForWebchatContent';

import { mountColorOptionPicker} from '../../../components/colorOptionPicker';
import { mountImageOptionPicker} from '../../../components/imageOptionPicker';
import { mountTextOptionPicker} from '../../../components/textOptionPicker';

import { renderChatBubbles } from './renderWebchatBubbles';

import { WRAPPER_OPTION_NAME } from '../constants';

import {
    IOptionPickerColorItem,
    IOptionPickerImageItem,
    IOptionPickerTextItem,
} from '@vfde-brix-ws10/option-picker';

/**
 * handle OptionPicker click
 * @param text
 * @param containerChatContentId
 * @param wrapperWebchatArea
 * @param onClick
 * @param webchatConfig because the config is needed for sendMessage, which is triggered when customer clicks an option
 */
export const clickOptionPicker = (message: string, containerChatContentId: string, onClick: (message: string) => void) => {
    onClick(message);

    // functionality of Brix???
    document.getElementById(containerChatContentId).remove();

    renderChatBubbles([message], true);

    return;
};

/**
 * handles different option picker variants
 * @param options coming from webchat response
 * @param wrapperWebchatArea
 * @param onClick
 * @param webchatConfig because the config is needed for sendMessage, which is triggered when customer clicks an option
 */
export const handleOptions = (options, onClick: (message: string) => void, wrapperContainerId?: string) => {
    const colorOptionPickerItems: IOptionPickerColorItem[] = [];
    const imageOptionPickerItems: IOptionPickerImageItem[] = [];
    const textOptionPickerItems: IOptionPickerTextItem[] = [];

    for (let j = 0; j < options.length; j++) {
        if (undefined !== options[j].color) {
            colorOptionPickerItems.push({
                stdValue: options[j].text,
                stdPrimaryLabel: options[j].text,
                stdColor: options[j].color,
            });

        } else if (undefined !== options[j].image) {
            imageOptionPickerItems.push({
                stdValue: options[j].text,
                stdPrimaryLabel: options[j].text,
                imgSrc: options[j].image,
            });
        } else {
            textOptionPickerItems.push({
                stdValue: options[j].text,
                stdPrimaryLabel: options[j].text,
            });
        }
    }

    const containerChatContentId = renderContainerForWebchatContent(WRAPPER_OPTION_NAME, wrapperContainerId);

    if (0 < colorOptionPickerItems.length) {

        mountColorOptionPicker (document.getElementById(containerChatContentId), containerChatContentId , colorOptionPickerItems,
            function (text) {
                clickOptionPicker(text, containerChatContentId, onClick);
            },
        );

    } else if (0 < imageOptionPickerItems.length) {

        mountImageOptionPicker (document.getElementById(containerChatContentId), containerChatContentId , imageOptionPickerItems,
            function (text) {
                clickOptionPicker(text, containerChatContentId, onClick);
            },
        );

    } else {

        mountTextOptionPicker (document.getElementById(containerChatContentId), containerChatContentId , textOptionPickerItems,
            function (text) {
                clickOptionPicker(text, containerChatContentId, onClick);
            },
        );
    }
};
